import type { FunctionalRole } from '../types';

/**
 * Dashboard personas gated off in the 2026-08 persona consolidation.
 *
 * This is a DASHBOARD gate only — not a role revocation. designer,
 * team_lead, engineer, and sales remain real, assignable FunctionalRoles
 * (see Settings > People & Roles); they're just not first-class dashboards
 * right now. Chris called these "maybe later", so the gate must stay
 * cheaply reversible: flip `legacyPersonasEnabled` server-side (see
 * backend/app/routers/users.py get_session_config, backed by the
 * `legacy_dashboard_personas` feature flag) and every one of these
 * dashboards, plus its nav entry, comes straight back — no code change.
 *
 * Two call sites must agree on this list or a user ends up with a nav
 * entry that dead-ends (or, worse, a dashboard nobody can navigate to):
 *   - RoleDashboard.tsx (persona → dashboard dispatch)
 *   - AppShell.tsx (the "Dashboards" nav section, one entry per
 *     functionalRole)
 */
export const GATED_FUNCTIONAL_ROLES: readonly FunctionalRole[] = [
  'designer',
  'team_lead',
  'engineer',
  'sales',
];

export function isPersonaGated(
  role: FunctionalRole | string | undefined,
  legacyPersonasEnabled: boolean,
): boolean {
  if (legacyPersonasEnabled) return false;
  return (GATED_FUNCTIONAL_ROLES as readonly string[]).includes(role ?? '');
}
